"use client";

import { DEFAULT_CURRENCY } from "@/config/constants";
import { capturePixelEvent } from "@/lib/pixel";
import { usePixelStore } from "@/stores/pixel";
import { TCourse } from "@/types/types";
import { useEffect, useRef } from "react";

export function TrackCourseDetailsPageViewEvent({ course }: { course: TCourse }) {
  const isPixelLoaded = usePixelStore((state) => state.isPixelLoaded);

  const hasFiredRef = useRef(false);

  useEffect(() => {
    if (!isPixelLoaded || hasFiredRef.current) return;

    capturePixelEvent("ViewContent", {
      content_name: course.title,
      content_category: "Course",
      content_type: "course",
      content_ids: [course.id],
      value: course.discountedPrice ? course.discountedPrice : course.originalPrice,
      currency: DEFAULT_CURRENCY,
    });

    hasFiredRef.current = true;
  }, [isPixelLoaded, course]);

  return null;
}

export function TrackCourseCheckoutPageViewEvent({ course }: { course: TCourse }) {
  const isPixelLoaded = usePixelStore((state) => state.isPixelLoaded);
  const hasFiredRef = useRef(false);

  useEffect(() => {
    if (!isPixelLoaded || hasFiredRef.current) return;

    capturePixelEvent("ViewContent", {
      content_name: course.title,
      content_category: "Course",
      content_type: "course",
      content_ids: [course.id],
      value: course.discountedPrice ? course.discountedPrice : course.originalPrice,
      currency: DEFAULT_CURRENCY,
    });

    hasFiredRef.current = true;
  }, [isPixelLoaded, course]);

  return null;
}

export function TrackCourseSearchEvent() {
  const isPixelLoaded = usePixelStore((state) => state.isPixelLoaded);
  const hasFiredRef = useRef(false);

  useEffect(() => {
    if (!isPixelLoaded || hasFiredRef.current) return;

    capturePixelEvent("Search");

    hasFiredRef.current = true;
  }, [isPixelLoaded]);

  return null;
}
